<template>
  <megabit-base-dialog :show-dialog="true" :width="1024">
    <template v-slot:body>
      <v-card color="rgba(0, 0, 0, 0.92)" dark dense>
        <v-card-title class="align-self-center">
          <span class="text-h6">{{ title }}</span>
        </v-card-title>
        <v-card-text>
          <v-form ref="form" v-model="formValid">
            <v-row dense class="d-block">
              <v-col md="3" xs="3" sm="3" class="d-sm-inline-block">
                <c-input
                  :label="'Código'"
                  :placeholder="'Código'"
                  :maxLength="6"
                  :isRequired="true"
                  v-model="form.CODIGO"
                />
              </v-col>
              <v-col md="4" xs="3" sm="4" class="d-sm-inline-block">
                <c-input
                  :label="'Classificação'"
                  :placeholder="'Classificação'"
                  :maxLength="12"
                  v-model="form.CLASSIFICACAO"
                />
              </v-col>
              <v-col md="5" xs="3" sm="5" class="d-sm-inline-block">
                <c-select-multiple
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="filiaisList"
                  :item.sync="form.filiais"
                  :size="size"
                  rotulo="Filial"
                  v-model="form.FILIAIS"
                  @input="updateFiliais()"
                >
                </c-select-multiple>
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="7" xs="3" sm="7" class="d-sm-inline-block">
                <c-input
                  :label="'Descrição'"
                  :placeholder="'Digite a descrição do departamento'"
                  :maxLength="40"
                  :minLength="3"
                  :isRequired="true"
                  v-model="form.DESCRICAO"
                />
              </v-col>
              <v-col md="5" xs="3" sm="5" class="d-sm-inline-block">
                <c-select
                  rotulo="Mostra saldo na venda"
                  itemText="label"
                  itemValue="value"
                  :lista="options"
                  :item.sync="selectedOption.option"
                  v-model="form.MOSTRASALDONAVENDA"
                />
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="6" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contasreceita"
                  :item.sync="form.contareceita"
                  rotulo="Contas de Receita"
                  v-model="form.CONTARECEITA"
                  @searchinput="updateContas($event, 'contareceita')"
                >
                </c-select>
              </v-col>
              <v-col md="6" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contasdevolucoes"
                  :item.sync="form.contadevolucoes"
                  rotulo="Contas de Devoluções"
                  v-model="form.CONTACUSTO"
                  @searchinput="updateContas($event, 'contadevolucoes')"
                >
                </c-select>
              </v-col>
            </v-row>
            <v-row dense class="d-block">
              <v-col md="6" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contascusto"
                  :item.sync="form.contacusto"
                  rotulo="Contas de Custo"
                  v-model="form.CONTACUSTO"
                  @searchinput="updateContas($event, 'contacusto')"
                >
                </c-select>
              </v-col>
              <v-col md="6" xs="3" sm="6" class="d-sm-inline-block">
                <c-select
                  item-text="DESCRICAO"
                  item-value="CODIGO"
                  :lista="contasboleto"
                  :item.sync="form.contaboleto"
                  rotulo="Contas de Boleto"
                  v-model="form.CONTABOLETO"
                  @searchinput="updateContas($event, 'contaboleto')"
                >
                </c-select>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <form-buttons @submitForm="validateForm()" @goBack="goBack()"/>
      </v-card>
    </template>
  </megabit-base-dialog>
</template>

<script>
import BaseDialog from '@/components/shared/base-dialog/BaseDialog'
import cInput from '@/components/shared/base-input/BaseInput'
import cSelect from '@/components/shared/base-input/BaseSelect.vue'
import cSelectMultiple from '@/components/shared/base-input/BaseSelectMultiple.vue'
import FormButtons from '@/components/shared/base-buttons/FormButtons'
import { departamentMixin } from '@/mixins/object/departament/DepartamentMixin'
import { mapActions, mapGetters } from 'vuex'

export default {
  mixins: [ departamentMixin ],
  components: {
    'megabit-base-dialog': BaseDialog,
    cInput,
    cSelect,
    cSelectMultiple,
    FormButtons
  },
  data: () => ({
    title: 'Cadastro de Departamentos',
    // Opções para o select MOSTRASALDONAVENDA
    options: [
      { label: 'Sim', value: 'S' },
      { label: 'Não', value: 'N' },
    ],
    // Opção selecionada MOSTRASALDONAVENDA
    selectedOption: {
      option: {},
    },
    isUpdate: false,
    registerDialog: true,
    formValid: false,
    contasreceita: [],
    contasdevolucoes: [],
    contascusto: [],
    contasboleto: [],
    filiaisList: [],
    size: 0,
    id: '',
    form: {
      CODIGO: '',
      CLASSIFICACAO: '',
      DESCRICAO: '',
      CONTABANCOBOLETO: '',
      CONTACUSTOS: '',
      CONTADEVOLUCAO: '',
      CONTARECEITAS: '',
      FILIAIS: '',
      MOSTRASALDONAVENDA: '',
      filiais: '',
      contareceita: '',
      contadevolucoes: '',
      contacusto: '',
      contaboleto: '',
    },
  }),
  computed: {
    ...mapGetters({ accountList: 'accountsModule/getComboBoxAccountList' }),
    ...mapGetters({ systemList: 'systemModule/getComboBoxListSystems' }),
    // Ver o breakpoint da página
    // breakpoint() {
    //   console.log(this.$vuetify.breakpoint.name);
    //   return this.$vuetify.breakpoint.name;
    // },
  },
  methods: {
    ...mapActions('departamentModule', [
      'getDepartament',
      'updateDepartament',
      'insertDepartament',
    ]),
    ...mapActions('accountsModule', ['getAccounts']),
    ...mapActions('systemModule', ['getSystems']),
    ...mapActions({
      showLoadingDialog: 'dialogModule/setShowLoadingDialog',
      setMessage: 'dialogModule/setLoadingDialogMessage'
    }),

    async validateForm() {
      if (!this.$refs.form.validate()) {
        this.$toasted.error('Verifique os campos em vermelho.');
        return
      }
      try {
        this.setMessage('Inserindo registro no sistema');
        this.showLoadingDialog(true);
        let response
        if (!this.isUpdate) {
          response = await this.insertDepartament(this.form)
        } else {
          response = await this.updateDepartament({
            form: this.form,
            id: this.id,
          })
        }
        this.showLoadingDialog(false);
        this.$toasted.success(response);
        this.$router.push({ name: 'Departamento' })
      } catch (error) {
        this.$toasted.error(error, {duration: null})
        this.showLoadingDialog(false);        
      }
    },
    goBack() {
      this.$router.push({ name: 'Departamento' })
    },
    async setData(id = null) {
      try {
        if (id) {
          this.title = 'Alteração de Departamento'
          let departament = await this.getDepartament(id)
          this.form = {
            ...departament,
          }
          // Obtém as filiais para o select FILIAIS
          await this.getFiliais()
          // Preenche o select CONTARECEITAS com o valor incial do banco
          let rec = this.form.contareceita
            ? [
                {
                  CODIGO: this.form.contareceita.CODIGO,
                  DESCRICAO:
                    this.form.contareceita.CODIGO +
                    ' - ' +
                    this.form.contareceita.NOME +
                    ' - ' +
                    this.form.contareceita.TIPO,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: 'Sem dados' }]
          this.contasreceita = rec
          // Preenche o select CONTADEVOLUCAO com o valor incial do banco
          let dev = this.form.contadevolucoes
            ? [
                {
                  CODIGO: this.form.contadevolucoes.CODIGO,
                  DESCRICAO:
                    this.form.contadevolucoes.CODIGO +
                    ' - ' +
                    this.form.contadevolucoes.NOME +
                    ' - ' +
                    this.form.contadevolucoes.TIPO,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: 'Sem dados' }]
          this.contasdevolucoes = dev
          // Preenche o select CONTACUSTO com o valor incial do banco
          let cust = this.form.contacusto
            ? [
                {
                  CODIGO: this.form.contacusto.CODIGO,
                  DESCRICAO:
                    this.form.contacusto.CODIGO +
                    ' - ' +
                    this.form.contacusto.NOME +
                    ' - ' +
                    this.form.contacusto.TIPO,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: 'Sem dados' }]
          this.contascusto = cust
          // Preenche o select CONTABANCOBOLETO com o valor incial do banco
          let bol = this.form.contaboleto
            ? [
                {
                  CODIGO: this.form.contaboleto.CODIGO,
                  DESCRICAO:
                    this.form.contaboleto.CODIGO +
                    ' - ' +
                    this.form.contaboleto.NOME +
                    ' - ' +
                    this.form.contaboleto.TIPO,
                },
              ]
            : [{ CODIGO: '', DESCRICAO: 'Sem dados' }]
          this.contasboleto = bol
          //Marca no select FILIAIS, as filiais selecionadas do banco
          let array = this.form.FILIAIS ? this.form.FILIAIS.split(',') : []
          let vv = []
          this.filiaisList = await this.systemList
          this.filiaisList.forEach((item) => {
            array.forEach(function(i) {
              if (i == item['CODIGO']) {
                vv.push(item)
              }
            })
          })
          this.form.filiais = vv ?? [{ label: '', value: '' }]
          // Quantidade de filiais marcadas
          this.size = this.form.filiais.length
          // Preenche o select MOSTRASALDONAVENDA com os dados iniciais do banco
          let o = this.options.filter((e) => {
            if (e.value == this.form.MOSTRASALDONAVENDA) {
              return e
            }
          })
          this.selectedOption.option = o[0]
          this.isUpdate = !this.isUpdate
        } else {
          // Inclusão de Departamentos
          await this.getFiliais()
        }
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      }
    },
    // Obtém as filiais cadastradas
    async getFiliais() {
      try {
        await this.getSystems({ page: 1 })
        this.filiaisList = this.systemList
      } catch (error) {
        this.$toasted.error(error, {duration: null})
      }
    },
    /*  Atualiza ComboBox do Conta de Receita, Devoluções, Custo e Boleto
        por código ou nome da Conta
     */
    async updateContas($event, tipo) {
      try {
        clearTimeout(this.timer)
        this.timer = setTimeout(() => {
          let param = $event && $event.target.value ? $event.target.value : null
          let obj = parseInt(param)
            ? { page: 1, codigo: parseInt(param) }
            : { page: 1, nome: param }
          this.getDados(obj, tipo)
        }, 600)
      } catch (error) {
        console.log('error', error)
      }
    },
    async getDados(payload, tipo) {
      try {
        await this.getAccounts(payload)

        if (tipo == 'contareceita') this.contasreceita = this.accountList
        else if (tipo == 'contadevolucoes')
          this.contasdevolucoes = this.accountList
        else if (tipo == 'contacusto') this.contascusto = this.accountList
        else this.contasboleto = this.accountList
      } catch (error) {
        this.$toasted.error(error, {duration: null});
      }
    },
    // Atualiza a quantidade de filiais selecionadas
    updateFiliais() {
      this.size = this.form.filiais.length
    },
  },
  mounted: function() {
    this.id = this.$route.params.id
    this.setData(this.id)
  },
}
</script>
